import _ from 'lodash';
import { authenticationLogin } from '@/api';
import {
  SET_TOKEN,
  SET_USER,
} from './mutation-types';

export default {
  state: {
    token: null,
    user: null,
  },
  getters: {
    authenticated: (state) => !!state.token,
  },
  actions: {
    ACT_AUTHENTICATE: async ({ commit, dispatch }, payload) => {
      dispatch('wait/start', 'authenticate', { root: true });
      const deviceToken = localStorage.getItem('fcm_token');
      const query = {
        ...payload,
      };
      if (deviceToken) {
        query.deviceToken = deviceToken;
      }
      return authenticationLogin(query).then((response) => {
        if (response.status === 200) {
          const token = _.get(response, 'headers.authorization');
          const data = _.get(response, 'data');
          if (token && data) {
            // SET_TOKEN emits the global "authenticated" event. The user must be
            // committed first so RBAC route guards see a fully initialized admin
            // on the very first redirect after login.
            commit(SET_USER, data);
            commit(SET_TOKEN, token);
          }
        }
      }).finally(() => {
        dispatch('wait/end', 'authenticate', { root: true });
      });
    },
    ACT_LOGOUT: ({ commit }) => {
      commit(SET_TOKEN, null);
      commit(SET_USER, null);
    },
  },
  mutations: {
    [SET_TOKEN](state, data) {
      state.token = data;
    },
    [SET_USER](state, data) {
      state.user = data;
    },
  },
  namespaced: true,
};
